import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardGetHistoricalList = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardHistoricalListRequestData) => {
        const response = await send<Types.ILeaderBoardHistoricalListRequestData, Types.ILeaderBoardHistoricalListResponseData>({
            ID: 71025,
            responses: [71026, 71027],
            description: 'Get player\'s historical leaderboards list',
            ...options
        });

        return response;
    }, [send]);
};
